/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 对接ADFS登录
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-01-10 15:38:53
 * @LastEditTime: 2023-01-10 16:24:19
 * @FilePath: /client-h5-v2/src/common-ts/loginADFS.ts
 */
import { apiGetUserInfoADFS } from '@/apis/login/userInfoADFS'
import store from '@/store/index'
import { getCookie, setCookie } from './utils'

export const loginADFS = (data:any) => {
  const urlParams = store.getters['global/params']
  if (data.botConfig.login.switch) {
    if (urlParams.sessionId) {
      setCookie('sessionId', urlParams.sessionId)
      const urlArr = window.location.href.split('?')
      window.location.href = urlArr[0]
    }
    const params = {
      sessionId: getCookie('sessionId') || urlParams.sessionId || '',
      requestId: '',
      timestamp: Date.parse(String(new Date()))
    }
    apiGetUserInfoADFS(params).then((res:any) => {
      if (res.data.data.url) {
        window.location.href = res.data.data.url
      } else {
        console.log(res.data.data)
        // 更新登陆状态
        store.commit('login/SET_AGENT_STATUS', true)
        // 缓存userId
        setCookie('userId', res.data.data.userInfo.email)
      }
    })
  }
}
